import { Dialog, DialogContent } from "@mui/material";
import { BackendUser } from "types/interfaces/adminUsers";
import BackendUserPanel from "./BackendUserPanel";

interface BackendUserEditModalProps {
  open: boolean;
  user: BackendUser | null;
  onClose: () => void;
  onUserUpdated: (user: BackendUser) => void;
  onUserDeleted?: () => void;
}

export default function BackendUserEditModal({
  open,
  user,
  onClose,
  onUserUpdated,
  onUserDeleted,
}: BackendUserEditModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      // Wide enough for every step of the form on one line.
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: "hidden",
          height: { xs: "90vh", sm: 840 },
          maxHeight: { xs: "90vh", sm: 840 },
        },
      }}
    >
      <DialogContent sx={{ p: 0, display: "flex", overflow: "hidden" }}>
        <BackendUserPanel
          user={user}
          onClose={onClose}
          onUserUpdated={onUserUpdated}
          onUserDeleted={onUserDeleted}
          fillViewport
        />
      </DialogContent>
    </Dialog>
  );
}
